import { useState } from 'react';

const useCheckValue = initialValue => {
  const [checked, setChecked] = useState(initialValue);
  const onClick = event => setChecked(!checked);

  return { checked, onClick, setChecked };
};

export default useCheckValue;
